import { PropsWithChildren } from 'react';

export enum LayoutContainerMods {
  Inner = 'inner',
  PaddingNone = 'paddingNone',
}

export type LayoutContainerProps = PropsWithChildren<{
  className?: string;
  mods?: LayoutContainerMods[];
}>;
